/**
 * User management & login
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('member.training', {
            url: '/' + urls.member.training.fr, // TODO : when multilang, change this to something dynamic
            abstract: true,
            views: {
                aside: {
                    templateUrl: 'src/views/member/member_aside.html'
                },
                content: {
                    controller: ['$scope', '$rootScope', '$filter', 'profile', 'drupal', '$state', function ($scope, $rootScope, $filter,  profile, drupal, $state) {

                        console.log('Member formation controller');

                        $scope.configSite = $rootScope.config.site;
                        $scope.submenu = [];
                        $scope.showTrainings = true;
                        if( $scope.configSite.account_trainings.show_trainings === 1) {
                            $scope.showTrainings = true;
                        }

                        // remove warning message
                        if ($scope.teaserPanel.css === 'info') {
                            angular.merge($scope.teaserPanel, { css: null, body: null });
                        }

                        if ($scope.breadcrumb.length > 2) {
                            $scope.breadcrumb.pop();
                        }

                        // retrieve all resume about person'stage .state('member.training.documents'
                        $scope.loading = true;
                        drupal.getAccountResume(profile.info.field_sfid).then(function (resume) {
                            $scope.resume = resume;
                        }).finally(function () {
                            $scope.loading = false;
                        });

                        $scope.user = {
                            experiences: profile.info.field_autres_experiences
                        };

                        $scope.update = function () {
                            $scope.trainingForm.pending = true;
                            if ($scope.trainingForm.$valid) {
                                profile.amend($scope.user).then(function () {
                                    $scope.trainingForm.pending = false;
                                }).catch(function (error) {
                                    $scope.trainingForm.pending = false;
                                });
                            } else {
                                $scope.trainingForm.pending = false;
                            }
                        };

                        $scope.openPrint = function () {
                            window.open($state.href('member.training.print'), 'glenans', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=500');
                        };
                        // end retrieve

                        // UNCOMMENT TO RETRIEVE MA PROGRESSION INTO MES FORMATIONS
                       if( $scope.showTrainings ){
                            // TODO: to uncomment if client want to have submenu "Mes formations" in menu "Mon CV nautique"
                            $scope.submenu.push({label: $filter('translate')('account.myProgress'), state: 'member.training.profil'});
                            $scope.breadcrumb.push({ label: $filter('translate')('account.myProgress'), state: 'member.training' });
                            $rootScope.title = $filter('translate')('account.title') + ' - ' + $filter('translate')('account.myTrainings');
                            $rootScope.titlePanel = $filter('translate')('account.myProgress');
                        }
                            $scope.submenu.push({label: $filter('translate')('account.myTrainingsDocuments'), state: 'member.training.documents'});

                        // DELETE ALL WHEN RETRIEVE MA PROGRESSION INTO MES FORMATIONS
                        //  if( $scope.showTrainings ){
                        //     $scope.submenu.push({label: $filter('translate')('account.myTrainingsDocuments'), state: 'member.training.documents'});
                        //     $scope.breadcrumb.push({ label: $filter('translate')('account.myTrainingsDocuments'), state: 'member.training.documents' });
                        //     $rootScope.title = $filter('translate')('account.title') + ' - ' + $filter('translate')('account.myTrainingsDocuments');
                        //     $rootScope.titlePanel = $filter('translate')('account.myTrainingsDocuments');
                        // }

                        // TODO: to uncomment if client want to have submenu "Titres et Diplômes Obtenus" in menu "Mon CV nautique"
                        // $scope.submenu.push({label: $filter('translate')('account.graduationTitle'), state: 'member.training.graduation'});
                    }],
                    // TODO: to uncomment if client whant to have tab menu with "Mes formations" "Mon CV nautique" "Titres et Diplômes Obtenus"
                    // DECOMMENTER POUR RETROUVER LES TABS
                    templateUrl: 'src/views/member/member_tabs.html'

                    // TODO:delete ligne if client whant to have tab menu with "Mes formations" "Mon CV nautique" "Titres et Diplômes Obtenus"
                    // COMMENTER POUR VIRER LES TABS
                    // templateUrl: 'src/views/member/member_training_documents.html'
                }
            }
        })
        .state('member.training.profil', {
            url: '',
            views: {
                subcontent: {
                    controller: ['$rootScope', '$scope', 'training', '$filter', 'drupal', function ($rootScope, $scope, $training, $filter, $drupal) {
                        $scope.loading = false;

                        $scope.config = $rootScope.config;

                        $scope.activeCategory = 'Croisière';
                        $scope.chooseCategory = function (index) {
                            $scope.activeCategory = index;
                        };

                        $scope.activePresentation = 'niveau';
                        $scope.changePresentation = function(){
                            $scope.loadingPresentation = true;

                            if( $scope.activePresentation === 'niveau' ){
                                $scope.activePresentation = 'domaine';
                            } else {
                                $scope.activePresentation = 'niveau';
                            }

                            if( $scope.activePresentation === 'niveau' ){
                                $drupal.getTraining().then(function(trainings) {
                                    $scope.trainings = $training.upgradeTrainings(trainings) || [];
                                }).finally(function() {
                                    $scope.loadingPresentation = false;
                                });
                            } else {
                                $drupal.getTrainingDomaine().then(function(trainings) {
                                    $scope.trainings = $training.upgradeTrainingsDomaine(trainings) || [];
                                }).finally(function() {
                                    $scope.loadingPresentation = false;
                                });
                            }
                        }

                        //$training.getTrainings().then(function (trainings) {
                        $drupal.getTraining().then(function(trainings) {
                            $scope.trainings = $training.upgradeTrainings(trainings) || [];
                            $scope.loading = false;

                            $rootScope.progress = angular.copy($scope.trainings);
                        });

                        $drupal.getLevelsUser().then(function(levels) {
                            $scope.levelsBar = levels;
                        });

                        $scope.levels = [
                            { label: $filter('translate')('trainings.acquiredNot'), rating: 0 },
                            { label: $filter('translate')('trainings.acquiredPending'), rating: 50 },
                            { label: $filter('translate')('trainings.acquiredDone'), rating: 100 }
                        ];

                        $scope.ratings = {
                            0: { text: $filter('translate')('trainings.acquiredNot')},
                            50: { text: $filter('translate')('trainings.acquiredPending')},
                            100: { text: $filter('translate')('trainings.acquiredDone')}
                        };

                        $scope.preconisation = {
                            comment: null,
                            filiere: null,
                            niveau: null
                        }

                        $drupal.getPreconisation().then(function (result) {
                            $scope.preconisation.comment = result.comment;
                            $scope.preconisation.filiere = result.activity;
                            $scope.preconisation.niveau = result.level;
                        });

                        var tptext = '';
                        $scope.levels.forEach(function (level) {
                            tptext += '<div class="grid grid-12 aqua-training--tooltip"><div class="grid-6 aqua-training--tooltip-label">' + level.label + ':</div> <div class="aqua-training--subskill--rating grid grid-6 rating-' + level.rating + '"></div> </div>';
                        });
                        $scope.tooltipText = tptext;
                    }],
                    templateUrl: 'src/views/member/member_training_profil.html'
                }
            }
        })
        .state('member.training.documents', {
            url: '/' + urls.member.documents.fr, // TODO : when multilang, change this to something dynamic,
            views: {
                subcontent: {
                    controller: ['$scope', 'profile', 'drupal', '$state', function ($scope, profile, drupal, $state) {
                        $scope.loading = true;
                        drupal.getAccountResume(profile.info.field_sfid).then(function (resume) {
                            $scope.resume = resume;
                        }).finally(function () {
                            $scope.loading = false;
                        });

                        $scope.user = {
                            experiences: profile.info.field_autres_experiences
                        };

                        $scope.update = function () {
                            $scope.trainingForm.pending = true;
                            if ($scope.trainingForm.$valid) {
                                profile.amend($scope.user).then(function () {
                                    $scope.trainingForm.pending = false;
                                }).catch(function (error) {
                                    $scope.trainingForm.pending = false;
                                });
                            } else {
                                $scope.trainingForm.pending = false;
                            }
                        };

                        $scope.openPrint = function () {
                            window.open($state.href('member.training.print'), 'glenans', 'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=500');
                        };
                    }],
                    templateUrl: 'src/views/member/member_training_documents.html'
                }
            }
        })
        .state('member.training.print', {
            url: '/' + urls.print.fr, // TODO : when multilang, change this to something dynamic,
            views: {
                '@': {
                    controller: ['$rootScope', '$scope', 'drupal', 'profile', 'tools', '$filter', 'moment', '$timeout', function ($rootScope, $scope, drupal, profile, tools, $filter, moment, $timeout) {
                        angular.merge($rootScope.site, { print: true });

                        $scope.breadcrumb = [
                            { label: $filter('translate')('account.myTrainings') }
                        ];
                        $rootScope.title = $filter('translate')('account.trainingsDocuments');
                        $rootScope.titlePanel = $filter('translate')('account.trainingsDocuments');

                        $scope.loading = true;
                        $scope.footer = tools.replace($filter('translate')('account.trainingsDocumentsDate'), {
                            date: moment().format('DD/MM/YYYY')
                        });
                        $scope.infoPrintUser = profile.info

                        $scope.experiences = profile.info.field_autres_experiences;

                        // launch print
                        $timeout(function () {
                            window.print();
                        }, 1000);

                        drupal.getAccountResume(profile.info.field_sfid).then(function (resume) {
                            console.log(resume);
                            $scope.resume = resume;
                            $scope.loading = false;
                        });
                        drupal.getLevelsUser().then(function(levels) {
                            $scope.levelsBar = [];
                            Object.entries(levels).forEach(function(e){
                                var level = null;
                                Object.entries(e[1]).forEach(function(elem){
                                    if(elem[1] == true){
                                        level = elem[0];
                                    }
                                });
                                $scope.levelsBar.push({
                                    name: e[0],
                                    levelName: level ? level : "Aucun"
                                })
                            });
                        });
                    }],
                    templateUrl: 'src/views/member/member_training_documents_print.html'
                }
            }
        })
        .state('member.training.graduation', {
            url: urls.member.training.graduation.fr, // TODO : when multilang, change this to something dynamic,
            views: {
                subcontent: {
                    controller: ['$scope', 'profile', 'drupal', 'moment', function ($scope, profile, drupal, moment) {
                        $scope.loading = true;
                        $scope.graduations = [];

                        drupal.getAccountGraduation(profile.info.field_sfid).then(function (result) {
                            $scope.graduations = result.sort(function (a, b) {
                                return moment(b.obtainingDate).diff(moment(a.obtainingDate)) > 0;
                            });
                        }).finally(function () {
                            $scope.loading = false;
                        });;
                    }],
                    template: '<div>' +
                        '  <p ng-if="loading" class="aqua-form--loader grid grid-middle grid-center">' +
                        '    <span class="aqua-form--loader-text">{{\'loading\' | translate}}...</span>' +
                        '  </p>' +
                        // '  <div ng-if="!loading">' +
                        // '    <graduationpanel content="graduations"></graduationpanel>' +
                        // '  </div>'+
                        '</div>'
                }
            }
        });
}]);
